import { API } from "aws-amplify"

export const subscribeNewsLetter = async (email:  string): Promise<void> => {
    return API.post('open-api', `/subscribe-newsletter`, { body: { email } })
}